import apiHandler from "../core/apiHandler";

const locationApi = apiHandler('locations');
export default locationApi;